import {Injectable} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {catchError, Observable, throwError, timeout} from 'rxjs';
import {NzMessageService} from "ng-zorro-antd/message";

@Injectable({
  providedIn: 'root'
})
export class TimeoutInterceptor implements HttpInterceptor {

  timeoutUrlConfigs = {
    '/login': {
      timeout: 15000,
      interfaceMessage: 'A tentativa de login falhou. Tente novamente mais tarde.',
      logErrorMessage: 'Login request timeout exceeded or failed.'
    },
    default: {
      timeout: 120000,
      interfaceMessage: 'Tempo de carregamento excedido. Tente novamente mais tarde. ',
      logErrorMessage: 'Request timeout exceeded.'
    }
  }

  constructor(private message: NzMessageService) {}

  private urlIsValidToIntercept(url: string): boolean {
     return url.length && !(new RegExp('\\.[\\w-]+$').test(url))
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let contextConfig = this.timeoutUrlConfigs.default
    if (this.urlIsValidToIntercept(req.url)) {
      const { pathname } = new URL(req.url)
      if (pathname in this.timeoutUrlConfigs) {
        contextConfig = this.timeoutUrlConfigs[pathname]
      }
    }
    return next.handle(req).pipe(
      timeout(contextConfig.timeout),
      catchError(err => {
        if (err.name === 'TimeoutError') {
          this.message.error(contextConfig.interfaceMessage)
          console.error(contextConfig.logErrorMessage)
          return throwError(() => new Error(contextConfig.logErrorMessage));
        }
        return throwError(() => err);
      })
    );
  }
}

export const TimeoutInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TimeoutInterceptor,
  multi: true,
}
